import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  ingredientColumns: [],
  fetchError: null,
  previewData: [],
  savedImportConfigs: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.IMPORT_INGREDIENT_FETCHING:
      return { ...state, fetching: payload };

    case types.IMPORT_INGREDIENT_SET_INGREDIENT_COLUMNS:
      return { ...state, ingredientColumns: payload };

    case types.IMPORT_INGREDIENT_CLEAR_ERROR:
      return { ...state, fetchError: null };

    case types.IMPORT_INGREDIENT_FETCH_ERROR:
      return { ...state, fetchError: payload };

    case types.IMPORT_INGREDIENT_SET_PREVIEW_DATA:
      return { ...state, previewData: payload };

    case types.IMPORT_INGREDIENT_SET_SAVED_IMPORT_CONFIGS:
      return { ...state, savedImportConfigs: payload };

    case types.IMPORT_INGREDIENT_RESET_STATE:
      return { ...INITIAL_STATE };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/importingredients/state/reducer.js